"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthFacilityCreateDto = void 0;
const health_facility_1 = require("../health.facility");
const misc_1 = require("../../../misc");
class HealthFacilityCreateDto extends (0, misc_1.generateCreateDto)(health_facility_1.HealthFacility, ['name', 'address', 'type', 'visitFeePercentage', 'priorityDoctorIds', 'iban']) {
}
exports.HealthFacilityCreateDto = HealthFacilityCreateDto;
